// extracted by mini-css-extract-plugin
export default {"wrap":"ProductDetail_wrap__Tc8LN","productInfo":"ProductDetail_productInfo__3OekC","productTxt":"ProductDetail_productTxt__MWdmb","backLink":"ProductDetail_backLink__5O1e1"};